import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../../../../styles/media.style';


const Container = styled.div`
  padding-bottom: 14px;
  ${media.tabletP`
    padding-bottom: 0;
  `};
`;

const StepContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 48px;
  margin-right: 48px;
`;

const Step = styled.div`
  width: 2px;
  height: 10px;
  overflow: visible;
  margin-top: 20px;
  border-left: 2px dotted #d8d8d8;
  box-sizing: border-box;
  font-size: 12px;
  color: #000;
  ${media.tabletP`
    height: 20px;
  `};
`;

const StepLabel = styled.span`
  display: inline-block;
  transform: translate(calc(-50% - 1px), -18px);
`;

const SliderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LabelLow = styled.div`
  width: 40px;
  font-size: 14px;
  color: #000;
  ${media.tabletP`
    font-size: 16px;
  `};
`;

const LabelHigh = styled.div`
  width: 40px;
  font-size: 14px;
  color: #000;
  text-align: right;
  ${media.tabletP`
    font-size: 16px;
  `};
`;

const SliderGroup = styled.div`
  position: relative;
  width: 100%;
  height: 28px;
`;

const BarBase = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background-color: #efefef;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.3) inset;
`;

const BarProgress = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 80%;
  height: 8px;
  border-radius: 4px;
  background: #91979b;
  background: -webkit-gradient(linear, left top, left bottom, from(#9ea4a8), to(#91979b));
  background: -webkit-linear-gradient(top, #9ea4a8, #91979b);
  background: -moz-linear-gradient(top, #9ea4a8, #91979b);
  background: -ms-linear-gradient(top, #9ea4a8, #91979b);
  background: -o-linear-gradient(top, #9ea4a8, #91979b);
  background-image: -ms-linear-gradient(top, #9ea4a8 0%, #91979b 100%);
`;

const Slider = styled.input`
  position: absolute;
  -webkit-appearance: none;
  height: 28px;
  width: 100%;
  background-color: transparent;
  outline: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: #9ba1a5;
    border: 7px solid #fff;
    box-sizing: border-box;
    height: 28px;
    width: 28px;
    border-radius: 50%;
    box-shadow: 0 3px 5px 3px rgba(0,0,0,0.2);
  }
`;


class RangeSlider extends React.Component {
  state = {
    value: 0,
    isLoadValue: false,
  };

  componentDidMount() {
    this.loadValue();
  }

  componentDidUpdate() {
    const question = this.props.question;
    const val = this.state.value || 0;
    this.props.handleChecked(null, question, question.answers[val]);
    this.loadValue();
  }

  loadValue = () => {
    const { damageLevel } = this.props;
    if(!this.state.isLoadValue && damageLevel >= 0) {
      this.setState({value: damageLevel, isLoadValue: true});
    }
  }

  handleInput = e => {
    const question = this.props.question;
    const val = e.target.value;
    this.setState({value: val});
    this.props.handleChecked(e, question, question.answers[val]);
  };
  
  render() {
    const { copy, question } = this.props;
    const { answers } = question;
    const min = 0;
    const max = answers.length - 1;
    const steps = [];

    for (let i = min; i <= max; i += 1) {
      steps.push(<Step key={i}><StepLabel>{i}</StepLabel></Step>);
    }

    return (
      <Container>
        <StepContainer>{steps}</StepContainer>
        <SliderContainer>
          <LabelLow>{copy.damageLevelLow || ''}</LabelLow>
          <SliderGroup>
            <BarBase />
            <BarProgress style={{ width: `${parseInt(this.state.value / max * 100, 10)}%` }} />
            <Slider type="range" min={min} max={max} step={1} value={this.state.value} onInput={e => this.handleInput(e)}  />
          </SliderGroup>
          <LabelHigh>{copy.damageLevelHigh || ''}</LabelHigh>
        </SliderContainer>
      </Container>
    );
  }
}

RangeSlider.propTypes = {
  copy: PropTypes.shape(),
  question: PropTypes.shape().isRequired,
  handleChecked: PropTypes.func.isRequired,
};

export default RangeSlider;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/Common/RangeSlider/RangeSlider.js